var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #002c5f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18767",
    "data-name": "Group 18767",
    transform: "translate(-1558 -8099)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18400",
    "data-name": "Rectangle 18400",
    className: "cls-1",
    width: 38,
    height: 38,
    rx: 6,
    transform: "translate(1558 8099)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18750",
    "data-name": "Group 18750",
    transform: "translate(1565.264 8105.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7561",
    "data-name": "Path 7561",
    className: "cls-2",
    d: "M36.85,27.137c3.167,0,3.54.011,4.79.07a6.6,6.6,0,0,1,2.2.407,3.925,3.925,0,0,1,2.251,2.251,6.6,6.6,0,0,1,.407,2.2c.056,1.25.07,1.627.07,4.79s-.011,3.54-.07,4.79a6.6,6.6,0,0,1-.407,2.2A3.925,3.925,0,0,1,43.842,46.1a6.6,6.6,0,0,1-2.2.407c-1.25.056-1.624.07-4.79.07s-3.54-.011-4.79-.07a6.6,6.6,0,0,1-2.2-.407,3.925,3.925,0,0,1-2.251-2.251,6.6,6.6,0,0,1-.407-2.2c-.056-1.25-.07-1.627-.07-4.79s.011-3.54.07-4.79a6.6,6.6,0,0,1,.407-2.2,3.925,3.925,0,0,1,2.251-2.251,6.6,6.6,0,0,1,2.2-.407c1.25-.056,1.627-.07,4.79-.07m0-2.137c-3.22,0-3.624.014-4.888.073a8.68,8.68,0,0,0-2.879.552,5.866,5.866,0,0,0-2.1,1.367,5.782,5.782,0,0,0-1.367,2.1,8.721,8.721,0,0,0-.552,2.879C25,33.236,24.99,33.64,24.99,36.86s.014,3.624.073,4.888a8.68,8.68,0,0,0,.552,2.879,5.866,5.866,0,0,0,1.367,2.1,5.782,5.782,0,0,0,2.1,1.367,8.721,8.721,0,0,0,2.879.552c1.264.059,1.668.073,4.888.073s3.624-.014,4.888-.073a8.68,8.68,0,0,0,2.879-.552,5.866,5.866,0,0,0,2.1-1.367,5.782,5.782,0,0,0,1.367-2.1,8.721,8.721,0,0,0,.552-2.879c.059-1.264.073-1.668.073-4.888s-.014-3.624-.073-4.888a8.68,8.68,0,0,0-.552-2.879,5.866,5.866,0,0,0-1.367-2.1,5.782,5.782,0,0,0-2.1-1.367,8.722,8.722,0,0,0-2.879-.552C40.474,25.014,40.07,25,36.85,25Z",
    transform: "translate(-24.99 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7562",
    "data-name": "Path 7562",
    className: "cls-2",
    d: "M51.768,45.68a6.088,6.088,0,1,0,6.088,6.088A6.088,6.088,0,0,0,51.768,45.68Zm0,10.041a3.953,3.953,0,1,1,3.953-3.953A3.954,3.954,0,0,1,51.768,55.721Z",
    transform: "translate(-39.908 -39.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    className: "cls-2",
    cx: 1.423,
    cy: 1.423,
    r: 1.423,
    transform: "translate(16.767 4.104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/Icon_Instagram.a7aea31c2ddb00feb3a93eaa13f1040e.svg";
export { ForwardRef as ReactComponent };